<script setup lang="ts">
import type { CaseRecord } from '../types'
import { formatDate } from '../lib/format'
import StatusBadge from './StatusBadge.vue'
import { caseRoute } from '../lib/case-route'
defineProps<{ record: CaseRecord; compact?: boolean }>()
</script>
<template>
  <article class="case-card" :class="{ compact }">
    <div class="card-meta"><span>{{ record.category }}</span><time :datetime="record.lastVerifiedAt">Revisto {{ formatDate(record.lastVerifiedAt) }}</time></div>
    <StatusBadge :status="record.editorialStatus" />
    <h3><RouterLink :to="caseRoute(record)">{{ record.shortTitle }}</RouterLink></h3>
    <p>{{ compact ? record.summary30s : record.dek }}</p>
    <div class="card-footer"><span>{{ record.sources.length }} fontes</span><RouterLink :to="caseRoute(record)" :aria-label="`Abrir dossiê: ${record.shortTitle}`">Abrir dossiê <span aria-hidden="true">→</span></RouterLink></div>
  </article>
</template>
